var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngledown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 9.20002C16.5 8.80002 15.9 8.80002 15.5 9.20002L12 12.7L8.50005 9.20002C8.10005 8.80002 7.50005 8.80002 7.10005 9.20002C6.70005 9.60002 6.70005 10.2 7.10005 10.6L11.3 14.8C11.5 15 11.7 15.1 12 15.1C12.3 15.1 12.5 15 12.7 14.8L16.9 10.6C17.3 10.2 17.3 9.60002 16.9 9.20002Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngledown);
export default __webpack_public_path__ + "static/media/angle down.53e70d6b1610367d3f38481e10de1f36.svg";
export { ForwardRef as ReactComponent };